import * as React from 'react';

import _t from 'i18n!nls/enterprise-legacy-learner-home';

type SvgObjectivesStep2Props = React.SVGProps<SVGSVGElement>;

const SvgObjectivesStep2: React.FC<SvgObjectivesStep2Props> = (props) => (
  <svg height={132} viewBox="0 0 313 132" width={313} role="presentation" {...props}>
    <title id="SvgObjectivesStep2-Title">{_t('Start learning')}</title>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h313v132H0z" fill="var(--cds-color-grey-25)" />
      <g transform="translate(56.001 45.026)">
        <rect
          fill="var(--cds-color-neutral-primary-invert)"
          height={55.08}
          rx={2}
          stroke="#var(--cds-color-grey-25)"
          width={47.069}
          x={0.5}
          y={0.5}
        />
        <path d="M2 0h44.069a2 2 0 012 2v21.033H0V2a2 2 0 012-2z" fill="var(--cds-color-green-600)" />
        <rect
          fill="var(--cds-color-neutral-primary-invert)"
          height={14.022}
          rx={2}
          stroke="#var(--cds-color-grey-25)"
          width={15.023}
          x={6.509}
          y={15.522}
        />
        <g fill="#var(--cds-color-grey-600)">
          <path d="M6.009 35.05h35.05v4.006H6.009zM6.009 43.062h25.035v4.005H6.01z" />
        </g>
      </g>
      <g transform="translate(110.079 45.026)">
        <rect
          fill="var(--cds-color-neutral-primary-invert)"
          height={55.08}
          rx={2}
          stroke="var(--cds-color-grey-25)"
          width={47.069}
          x={0.5}
          y={0.5}
        />
        <path d="M2 0h44.069a2 2 0 012 2v21.033H0V2a2 2 0 012-2z" fill="var(--cds-color-red-500)" />
        <rect
          fill="var(--cds-color-neutral-primary-invert)"
          height={14.022}
          rx={2}
          stroke="var(--cds-color-grey-25)"
          width={15.023}
          x={6.509}
          y={15.522}
        />
        <g fill="var(--cds-color-grey-600)">
          <path d="M6.009 35.05h35.05v4.006H6.009zM6.009 43.062h25.035v4.005H6.01z" />
        </g>
      </g>
      <g transform="translate(164.156 45.026)">
        <rect
          fill="var(--cds-color-neutral-primary-invert)"
          height={55.08}
          rx={2}
          stroke="var(--cds-color-grey-25)"
          width={47.069}
          x={0.5}
          y={0.5}
        />
        <path d="M2 0h44.069a2 2 0 012 2v21.033H0V2a2 2 0 012-2z" fill="var(--cds-color-grey-600)" />
        <rect
          fill="var(--cds-color-neutral-primary-invert)"
          height={14.022}
          rx={2}
          stroke="var(--cds-color-grey-25)"
          width={15.023}
          x={6.509}
          y={15.522}
        />
        <g fill="var(--cds-color-grey-600)">
          <path d="M6.009 35.05h35.05v4.006H6.009zM6.009 43.062h25.035v4.005H6.01z" />
        </g>
      </g>
      <g transform="translate(218.234 45.026)">
        <rect
          fill="var(--cds-color-neutral-primary-invert)"
          height={55.08}
          rx={2}
          stroke="var(--cds-color-grey-25)"
          width={47.069}
          x={0.5}
          y={0.5}
        />
        <path d="M2 0h44.069a2 2 0 012 2v21.033H0V2a2 2 0 012-2z" fill="var(--cds-color-purple-800)" />
        <rect
          fill="var(--cds-color-neutral-primary-invert)"
          height={14.022}
          rx={2}
          stroke="var(--cds-color-grey-25)"
          width={15.023}
          x={6.509}
          y={15.522}
        />
        <g fill="var(--cds-color-grey-600)">
          <path d="M6.009 35.05h35.05v4.006H6.009zM6.009 43.062h25.035v4.005H6.01z" />
        </g>
      </g>
      <g transform="translate(55 24.253)">
        <rect fill="var(--cds-color-grey-25)" height={5.356} rx={2.678} width={73.105} y={5} />
        <path
          d="M54.026 2.614l-3.399 2.134a1.302 1.302 0 01-1.384 0L45.91 2.655a1 1 0 01.526-1.847l7.052-.04a1 1 0 01.538 1.846z"
          fill="var(--cds-color-grey-700)"
        />
      </g>
      <path d="M57.678 29.253h27.347v5.356H57.678a2.678 2.678 0 010-5.356z" fill="var(--cds-color-yellow-200)" />
      <path
        d="M90.18 26.027a1.865 1.865 0 00-1.331.273l-5.03 3.602v3.803a1.83 1.83 0 00.87 1.48l4.102 2.536a1.864 1.864 0 001.997-.022l5.029-3.62v-3.645a1.84 1.84 0 00-.883-1.626z"
        fill="var(--cds-color-neutral-primary-invert)"
        stroke="var(--cds-color-yellow-200)"
        strokeWidth={2}
      />
    </g>
  </svg>
);

export default SvgObjectivesStep2;
